import React, { useEffect, useState } from "react";
import { getMasterObligation } from "../apis/userApis";
import { useParams } from "react-router-dom";
import {
  formatDatetoISO,
  getActFrequencyText,
  getDepartmentText,
  getRecFrequencyText,
} from "./utilities";
import { Paper, Text } from "@mantine/core";
import BusinessUnitName from "../componenets/getBuName";
import { useDispatch, useSelector } from "react-redux";
import "./common.css";

const ViewMasterObligation = () => {
  const { id } = useParams();
  const [config, setConfig] = useState({
    loading: true,
    obligation: null,
  });
  useEffect(() => {
    const getMasterObligationDetails = async () => {
      const response = await getMasterObligation({ id });
      if (response.success) {
        setConfig({
          loading: false,
          obligation: response.obligation,
        });
      } else {
        setConfig({
          ...config,
          loading: false,
        });
      }
    };
    getMasterObligationDetails();
  }, []);

  return (
    <div>
      {!config.loading && config.obligation && (
        <>
          {/* <Text className="m-4 font-bold text-md">obligation {id} details</Text> */}

          {!config.loading && (
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <Text size="xl" className="font-bold">
                  Obligation-{config.obligation.id}
                </Text>
                <Text size="sm" style={{ color: "#1b6f8d" }}>
                  <span className="font-normal">Created On: </span>
                  {formatDatetoISO(config.obligation.createdAt)}
                </Text>
              </div>

              <Paper withBorder radius="md" p="md" mb="md">
                <Text
                  className="font-semibold mb-4"
                  style={{ color: "#1b6f8d", letterSpacing: "0.03em" }}
                >
                  CONTRACT DETAILS
                </Text>
                <div className="grid grid-cols-4 gap-6 text-left">
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Department
                    </Text>
                    <Text className="font-medium mt-1">
                      {getDepartmentText(config.obligation.department)}
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      AIN
                    </Text>
                    <Text className="font-medium mt-1">
                      {config.obligation.local && "local-"}
                      {config.obligation.connectedAgreement}
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Contract Category
                    </Text>
                    <Text className="font-medium mt-1">{config.obligation.extraCol1}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Business Unit
                    </Text>
                    <Text className="font-medium mt-1">
                      <BusinessUnitName
                        businessUnitId={config.obligation.businessUnit}
                      />
                    </Text>
                  </div>
                </div>
              </Paper>

              <Paper withBorder radius="md" p="md">
                <Text
                  className="font-semibold mb-4"
                  style={{ color: "#1b6f8d", letterSpacing: "0.03em" }}
                >
                  OBLIGATION DETAILS
                </Text>
                <div className="grid grid-cols-4 gap-6 text-left mb-4">
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Clause No.
                    </Text>
                    <Text className="font-medium mt-1">{config.obligation.clNo}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Title
                    </Text>
                    <Text className="font-medium mt-1">{config.obligation.title}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Assigned To
                    </Text>
                    <Text className="font-medium mt-1">{config.obligation.assignTo.name}</Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Act. Frequency
                    </Text>
                    <Text className="font-medium mt-1">
                      {getActFrequencyText(config.obligation.actFrequency)}
                    </Text>
                  </div>
                </div>

                <div className="mb-4">
                  <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                    Obligation
                  </Text>
                  <Text className="font-medium mt-1">{config.obligation.desc}</Text>
                </div>

                <div className="grid grid-cols-4 gap-6 text-left">
                  {config.obligation.actFrequency !== 1 && (
                    <div>
                      <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                        Rec. Frequency
                      </Text>
                      <Text className="font-medium mt-1">
                        {getRecFrequencyText(config.obligation.recFrequency)}
                      </Text>
                    </div>
                  )}
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Reminder Time
                    </Text>
                    <Text className="font-medium mt-1">
                      {config.obligation.reminderTime}-days
                    </Text>
                  </div>
                  <div>
                    <Text size="xs" className="blue uppercase" style={{ letterSpacing: "0.04em" }}>
                      Due Date
                    </Text>
                    <Text className="font-medium mt-1">
                      {formatDatetoISO(config.obligation.endDate)}
                    </Text>
                  </div>
                </div>
              </Paper>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ViewMasterObligation;
